import BigNumber from "bignumber.js/bignumber";

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
});

export const BLOCKS_PER_YEAR = new BigNumber(10512000);
export const BSC_BLOCK_TIME = 3;
export const BLOCK_LAUNCH = 13049577;

export const CHAIN_ID = parseInt(import.meta.env.VITE_APP_CHAIN_ID);